<div class="d-flex flex-row align-items-center mb-4">
  <span class="text mx-auto" [ngClass]="{ bold: !formControl.value }">{{ props.leftResourceId | apmTranslate }}</span>
  <mat-slide-toggle [id]="uuid" [formControl]="formControl" [formlyAttributes]="field"></mat-slide-toggle>
  <span class="text mx-auto" [ngClass]="{ bold: formControl.value }">{{ props.rightResourceId | apmTranslate }}</span>
</div>
